module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [(_vm.$store.state.total <= 0) ? _c('h1', {
    staticClass: "app__title"
  }, [_vm._v("Last FM Search")]) : _c('h1', [_vm._v(_vm._s(_vm.$store.state.total) + " Results for " + _vm._s(_vm.$store.state.searchTearm))]), _vm._v(" "), _c('search')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25667dd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 59
// module chunks = 1